import React, { useState, useEffect } from "react";
import Template from "../../components/Template";
import api from "../../services/api";
import ConfirmationModal from "../../components/ConfirmationModal";
import SuccessModal from "../../components/SuccessModal";
import { required, isFile, isDate } from "../../utils/validationRules";
import { useValidation } from "../../hooks/useValidation";
import FormLabel from "../../components/FormLabel";
import { useNavigate } from 'react-router-dom';
import { formatDateWithHour } from "../../utils/date";
import config from "../../config";
import usePermission from "../../hooks/usePermission";

const CadastrarDocumento = ({ documentoId }) => {
    const navigate = useNavigate();
    const isEditMode = Boolean(documentoId);
    const podeDeletar = usePermission("DELETAR_DOCUMENTO");

    const [showConfirmDialog, setShowConfirmDialog] = useState(false);
    const [showConfirmRemoveArchiveDialog, setShowConfirmRemoveArchiveDialog] = useState(false);
    const [showSuccessDialog, setShowSuccessDialog] = useState(false);
    const [showConfirmDeleteRegister, setShowConfirmDeleteRegister] = useState(false);

    const [categorias, setCategorias] = useState([]);
    const [statusList, setStatusList] = useState([]);
    const [showDialog, setShowDialog] = useState(false); // Estado para controlar o modal    
    const [selectedPdf, setSelectedPdf] = useState("");
    const [formData, setFormData] = useState({
        idDocumento: "PEND", // Simulando ID fixo como no design
        nomeDocumento: "", // Exemplo preenchido
        categoria: "",
        validade: "",
        status: "",        
        arquivosAtuais: [], // Para arquivos já existentes no backend
        novosArquivos: [], // Para novos arquivos selecionados para upload
        dataUpload: new Date().toLocaleString(), // Exemplo preenchido, agora pode ser atualizado a cada segundo na criação
        observacoes: "",
    });

    const { errors, handleChange, validateForm } = useValidation(formData, {
        nomeDocumento: [required],
        categoria: [required],
        status: [required],
        // Validação para garantir que há pelo menos um arquivo (existente ou novo)
        arquivos: [ // Usaremos 'arquivos' como um campo virtual para a validação
            () => (isEditMode && formData.arquivosAtuais.length > 0) || formData.novosArquivos.length > 0 ? false : "Pelo menos um arquivo é obrigatório."
            ,
        ],
    });

    useEffect(() => {
        // Atualiza a data de upload a cada segundo
        let interval;
        if (!isEditMode) {
            interval = setInterval(() => {
                setFormData((prevData) => ({
                    ...prevData,
                    dataUpload: new Date().toLocaleString(),
                }));
            }, 1000);
        }
        // Carregar categorias e status da API
        const fetchData = async () => {
            try {
                const [categoriasRes, statusRes] = await Promise.all([
                    api.get("/categorias/byModule/nome/documentos"),
                    api.get("/statuses/byModule/nome/documentos"),
                ]);
                setCategorias(categoriasRes.data);
                setStatusList(statusRes.data);
            } catch (error) {
                console.error("Erro ao carregar dados:", error);
            }
        };
        fetchData();

        // Se for modo de edição, carregar os dados do documento
        if (isEditMode) {
            const fetchDocumento = async () => {
                try {
                    const response = await api.get(`/documentos/${documentoId}`);
                    const doc = response.data;
                    console.log("Documento completo recebido da API:", doc);
                    console.log("doc.arquivos recebido da API:", doc.arquivos);                    
                    setFormData({
                        idDocumento: doc.id || "PEND",
                        nomeDocumento: doc.nomeDocumento || "",
                        categoria: doc.categoriaId || "",
                        validade: doc.validade ? doc.validade.split('T')[0] : "",
                        status: doc.statusId || "",                        
                        arquivosAtuais: Array.isArray(doc.arquivos) ? doc.arquivos : [],
                        novosArquivos: [], // Inicializa novosArquivos como array vazio no modo de edição
                        dataUpload: formatDateWithHour(doc.dataUpload),
                        observacoes: doc.observacoes || "",
                    });
                } catch (error) {
                    console.error("Erro ao carregar documento:", error);
                    alert("Erro ao carregar o documento. Tente novamente.");
                }
            };
            fetchDocumento();
        }
        if (!isEditMode) {
            return () => clearInterval(interval);
        }

    }, [documentoId, isEditMode]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleNewFileChange = (e) => {
        // Adiciona os novos arquivos ao array de novosArquivos (mantendo os já existentes na lista de "novos")
        setFormData({ ...formData, novosArquivos: [...formData.novosArquivos, ...Array.from(e.target.files)] });
    };

    const handleRemoveNewFile = (indexToRemove) => {
        setFormData(prevData => ({
            ...prevData,
            novosArquivos: prevData.novosArquivos.filter((_, index) => index !== indexToRemove)
        }));
    };
    

    const handleSubmit = async (e) => {
        e.preventDefault();

        /*if (validateForm(formData)) {
            setShowConfirmDialog(true);
        }*/

    };

    const handleConfirm = async () => {
        setShowConfirmDialog(false);

        try {
            const data = new FormData();
            data.append("nomeDocumento", formData.nomeDocumento);
            data.append("categoriaId", formData.categoria);
            if (formData.validade) data.append("validade", formData.validade); // Só adiciona se houver validade
            data.append("statusId", formData.status);
            data.append("arquivo", formData.arquivo);
            data.append("observacoes", formData.observacoes);

            // Anexar todos os novos arquivos ao FormData. O nome 'arquivos' deve corresponder ao que o Multer.array() espera no backend
            formData.novosArquivos.forEach((file) => {
                data.append(isEditMode ? "novosArquivos":"arquivos", file); // Ou 'novosArquivos' se for a rota de PUT
            });
            

            let response;
            if (isEditMode) {
                // Enviar requisição PUT para atualizar
                response = await api.put(`/documentos/${documentoId}`, data, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                });
            } else {
                // Enviar requisição POST para criar
                response = await api.post("/documentos", data, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                });
            }



            setShowSuccessDialog(true);

            setTimeout(() => {
                setShowSuccessDialog(false);
                if (isEditMode) {
                    // Em modo de edição, recarregar a página para exibir os arquivos recém-adicionados
                    window.location.reload(); 
                } else {
                    setFormData({
                        idDocumento: "PEND", // Simulando ID fixo como no design
                        nomeDocumento: "",
                        categoria: "",
                        validade: "",
                        status: "",
                        arquivosAtuais: [], // Limpa
                        novosArquivos: [], // Limpa
                        dataUpload: new Date().toLocaleString(), // Reseta
                        observacoes: "",
                    });
                    window.location.href = "/documentos";
                }

            }, 3000);
        } catch (error) {
            if (error.response?.status === 401) {
                alert("Sua sessão expirou. Por favor, faça login novamente.");
                localStorage.removeItem("token");
                window.location.href = "/login";
            } else {
                console.error(`Erro ao ${isEditMode ? "atualizar" : "cadastrar"} documento:`, error);
                alert(`Erro ao ${isEditMode ? "atualizar" : "cadastrar"} documento. Verifique os dados e tente novamente.`);
            }

        }


    };

    const handleCancel = () => {
        setShowConfirmDialog(false);
    };

    const handleBack = () => {
        navigate('/documentos');
    };

    const handleShowPdf = (url) => {
        setSelectedPdf(url);
        setShowDialog(true);
    };

    const handleCloseDialog = () => {
        setShowDialog(false);
    };

    const handleDeleteExistingFile = async (fileId) => {
        try {
            await api.delete(`/documentos/arquivos/${fileId}`); // Chama a nova rota de exclusão de arquivo específico
            // Remove o arquivo da lista de arquivos atuais no estado
            setShowConfirmRemoveArchiveDialog(false);
            setShowSuccessDialog(true);
            setFormData(prevData => ({ ...prevData, arquivosAtuais: prevData.arquivosAtuais.filter(file => file.id !== fileId) })); // Atualiza a lista exibida            
        } catch (error) {
            console.error(`Erro ao remover arquivo:`, error);
            alert(`Erro ao remover arquivo.`);
        }
    }

    const handleDeleteRegister = async () => {
        try {   
            await api.delete(`/documentos/${documentoId}`);
            setShowConfirmDeleteRegister(false);
            window.location.href = '/documentos'
        } catch (error) {
            console.error(`Erro ao remover arquivo:`, error);
            alert(`Erro ao remover arquivo.`);
        }
    }

    return (
        <Template>
            <form onSubmit={handleSubmit} className="w-full px-4 py-6 flex flex-col gap-8">
                {/* Título da Página */}
                <div>
                    <h1 className="text-2xl text-stone-800 font-medium">{isEditMode ? "Editar Documento" : "Cadastrar Documento"}</h1>
                </div>

                {/* Dados do Documento */}
                <div className="flex flex-col gap-4">
                    <h2 className="text-base text-stone-600 font-medium">Dados do Documento</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                        {/* ID Documento */}
                        <div className="flex flex-col gap-1.5">
                            <FormLabel
                                htmlFor="idDocumento"
                                isRequired={false}
                            >
                                ID Documento
                            </FormLabel>
                            <div className="pl-3 pr-14 py-2 bg-white rounded-md border border-slate-300">
                                <span className="text-base text-slate-700">{formData.idDocumento}</span>
                            </div>
                        </div>

                        {/* Nome do Documento */}
                        <div className="flex flex-col gap-1.5 md:col-span-2 lg:col-span-3">
                            <FormLabel
                                htmlFor="nomeDocumento"
                                isRequired={true}
                            >
                                Nome do Documento
                            </FormLabel>
                            <input
                                type="text"
                                name="nomeDocumento"
                                value={formData.nomeDocumento}
                                onChange={handleInputChange}
                                className={`pl-3 pr-14 py-2 bg-white rounded-md  border ${errors.nomeDocumento ? "border-red-600" : "border-slate-300"} text-base text-slate-700`}
                                placeholder="Digite o nome do documento"
                            />
                            {errors.nomeDocumento && <p className="text-red-600 text-sm">{errors.nomeDocumento}</p>}
                        </div>

                        {/* Data do Upload */}
                        <div className="flex flex-col gap-1.5">
                            <label className="text-sm text-slate-700 font-medium">Data do Upload</label>
                            <div className="pl-3 pr-14 py-2 bg-white rounded-md border border-slate-300">
                                <span className="text-base text-slate-700">{formData.dataUpload}</span>
                            </div>
                        </div>

                        {/* Tipo */}
                        <div className="flex flex-col gap-1.5">
                            <FormLabel
                                htmlFor="categoria"
                                isRequired={true}
                            >
                                Tipo
                            </FormLabel>
                            <select
                                name="categoria"
                                value={formData.categoria}
                                onChange={handleInputChange}
                                className={`px-3 py-2 bg-white rounded-md border ${errors.nomeDocumento ? "border-red-600" : "border-slate-300"} text-base text-slate-700`}
                            >
                                <option value="">Selecionar</option>
                                {categorias.map((cat) => (
                                    <option key={cat.id} value={cat.id}>
                                        {cat.nome}
                                    </option>
                                ))}
                            </select>
                            {errors.categoria && <p className="text-red-600 text-sm">{errors.categoria}</p>}
                        </div>

                        {/* Validade */}
                        <div className="flex flex-col gap-1.5">
                            <FormLabel
                                htmlFor="validade"
                                isRequired={false}
                            >
                                Validade
                            </FormLabel>
                            <input
                                type="date"
                                name="validade"
                                value={formData.validade}
                                onChange={handleInputChange}
                                className={`pl-3 pr-14 py-2 bg-white rounded-md border ${errors.validade ? "border-red-600" : "border-slate-300"} text-base text-slate-700`}
                            />
                            {errors.validade && <p className="text-red-600 text-sm">{errors.validade}</p>}
                        </div>

                        {/* Status */}
                        <div className="flex flex-col gap-1.5">
                            <FormLabel
                                htmlFor="status"
                                isRequired={true}
                            >
                                Status
                            </FormLabel>
                            <select
                                name="status"
                                value={formData.status}
                                onChange={handleInputChange}
                                className={`px-3 py-2 bg-white rounded-md border ${errors.status ? "border-red-600" : "border-slate-300"} text-base text-slate-700`}
                            >
                                <option value="">Selecionar</option>
                                {statusList.map((stat) => (
                                    <option key={stat.id} value={stat.id}>
                                        {stat.nome}
                                    </option>
                                ))}
                            </select>
                            {errors.status && <p className="text-red-600 text-sm">{errors.status}</p>}
                        </div>
                    </div>
                </div>

                {/* Enviar Documento */}
                <div className="flex flex-col gap-4">
                    <FormLabel
                        htmlFor="arquivo"
                        isRequired={!isEditMode}
                    >
                        Enviar Documento
                    </FormLabel>
                    <div className="flex flex-col gap-4">
                        {/* Se estiver em modo de edição e existirem arquivos no backend, exibe a lista de botões para cada arquivo */}
                        {isEditMode && formData.arquivosAtuais && formData.arquivosAtuais.length > 0 && ( // AQUI: Adicionado 'formData.arquivosAtuais &&'
                            <div className="flex flex-col gap-2 border p-4 rounded-md bg-gray-50">
                                <h3 className="text-sm font-medium text-stone-700">Arquivos Existentes:</h3>
                                {formData.arquivosAtuais.map((file) => (
                                    <div key={file.id} className="flex flex-wrap items-center gap-2 text-sm text-slate-700 p-2 border rounded-md bg-white shadow-sm">
                                        <span className="flex-grow">{file.nomeArquivoOriginal}</span>
                                        <button
                                            type="button"
                                            className="px-2 py-1 bg-blue-600 text-white rounded-md flex items-center gap-1"
                                            onClick={() => { handleShowPdf(file.caminhoArquivo) }}
                                        >
                                            <img className="w-3 h-3" src="/images/icon/search-white.png" alt="Ver" /> Ver
                                        </button>
                                        <button
                                            type="button"
                                            className="px-2 py-1 bg-green-600 text-white rounded-md flex items-center gap-1"
                                            onClick={() => {
                                                const link = document.createElement("a");
                                                link.target = '_blank';
                                                link.href = config.urlArquivo(file.caminhoArquivo);
                                                link.setAttribute("download", file.nomeArquivoOriginal);
                                                document.body.appendChild(link);
                                                link.click();
                                                link.remove();
                                            }}
                                        >
                                            <img className="w-3 h-3" src="/images/icon/download.png" alt="Download" /> Download
                                        </button>
                                        <button
                                            type="button"
                                            className="px-2 py-1 bg-red-600 text-white rounded-md flex items-center gap-1"
                                            onClick={async () => {
                                                setShowConfirmRemoveArchiveDialog(true);
                                                setSelectedPdf(file.id); // Armazena o ID do arquivo a ser removido no estado temporário
                                            }}
                                        >
                                            <img className="w-3 h-3" src="/images/icon/x-circle.png" alt="Remover" /> Remover
                                        </button>
                                    </div>
                               ))}
                            </div>
                        )}

                        {/* Input para adicionar novos arquivos */}
                        <div className="relative flex items-center gap-4">
                            <input
                                name="novosArquivos"
                                type="file"
                                accept=".pdf" // Aceita apenas PDFs, como no original
                                multiple // Permite a seleção de múltiplos arquivos de uma vez
                                onChange={handleNewFileChange}
                                className={`absolute inset-0 opacity-0 cursor-pointer `}
                            />
                            <div className={`w-full pl-3 pr-14 py-2 bg-white rounded-md border ${errors.arquivos ? "border-red-600" : "border-slate-300"} flex items-center gap-2`} >
                                <span className="text-base text-slate-400">
                                    {formData.novosArquivos && formData.novosArquivos.length > 0 ? `${formData.novosArquivos.length} arquivo(s) selecionado(s)` : "Selecionar novos documentos"}
                                </span>
                            </div>
                        </div>
                        {errors.arquivos && <p className="text-red-600 text-sm">{errors.arquivos}</p>}

                        {/* Exibir novos arquivos selecionados (antes do upload) e opção para remover */}
                        {formData.novosArquivos.length > 0 && (
                            <div className="flex flex-col gap-2 mt-2">
                                <h3 className="text-sm font-medium text-stone-700">Novos Arquivos para Upload:</h3>
                                {formData.novosArquivos.map((file, index) => (
                                    <div key={index} className="flex items-center justify-between gap-2 text-sm text-slate-700 p-2 border rounded-md bg-white shadow-sm">
                                        <span>{file.name}</span>
                                        <button type="button" onClick={() => handleRemoveNewFile(index)} className="text-red-500 hover:text-red-700 font-bold">X</button>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>

                {/* Observações */}
                <div className="flex flex-col gap-4">
                    <h2 className="text-base text-stone-600 font-medium">Observações</h2>
                    <textarea
                        name="observacoes"
                        rows={4}
                        value={formData.observacoes}
                        onChange={handleInputChange}
                        className="w-full px-3 py-2 bg-white rounded-md border border-slate-300 text-sm text-slate-700 resize-none"
                        placeholder="Digite suas observações aqui..."
                    />
                </div>

                {/* Botões de Ação */}
                <div className="flex items-center w-full gap-4">
                    {isEditMode && podeDeletar && (
                        <button
                            type="button"
                            className="px-4 py-2 bg-red-600 text-white text-sm font-medium rounded-md flex items-center gap-2"
                            onClick={() => setShowConfirmDeleteRegister(true)}
                        >
                            <img className="w-4 h-4" src="/images/icon/trash-2.png" alt="Apagar" />
                            <span>Apagar</span>
                        </button>
                    )}

                    <div className="flex gap-4 ml-auto">
                        <button
                            type="button"
                            className="px-4 py-2 bg-stone-600 text-white text-sm font-medium rounded-md flex items-center gap-2"
                            onClick={handleBack}
                        >
                            <img className="w-4 h-4" src="/images/icon/arrow-left.png" alt="Voltar" />
                            <span>Voltar</span>
                        </button>

                        <button
                            type="submit"
                            className="px-4 py-2 bg-stone-600 text-white text-sm font-medium rounded-md flex items-center gap-2"                            
                            onClick={() => { // Valida e abre o modal de confirmação ao clicar no botão Salvar
                                if (validateForm(formData)) {
                                    setShowConfirmDialog(true);
                                }}}
                        >
                            <img className="w-4 h-4" src="/images/icon/save.png" alt="Salvar" />
                            <span>Salvar</span>
                        </button>
                    </div>
                </div>

                {/* Modais */}
                <ConfirmationModal
                    isVisible={showConfirmDialog}
                    onConfirm={handleConfirm}
                    onCancel={handleCancel}
                    message='Deseja salvar as informações?'
                />
                <SuccessModal
                    isVisible={showSuccessDialog}
                    message="Informações salvas com sucesso!"
                    onClose={() => setShowSuccessDialog(false)}
                />
                <ConfirmationModal
                    isVisible={showConfirmRemoveArchiveDialog}
                    onConfirm={() => handleDeleteExistingFile(selectedPdf)} // Passa o ID do arquivo para a função de deleção
                    onCancel={() => { setShowConfirmRemoveArchiveDialog(false) }}
                    message='Deseja remover o arquivo deste documento?'
                    textButtonConfirm='Sim'
                />

                <ConfirmationModal
                    isVisible={showConfirmDeleteRegister}
                    onConfirm={handleDeleteRegister}
                    onCancel={() => { setShowConfirmDeleteRegister(false) }}
                    message='Deseja apagar este registro?'
                    textButtonConfirm='Sim'
                />

                {showDialog && (
                    <div className="fixed top-0 left-0 w-full h-full bg-black/90 z-50 p-10 flex-col justify-start items-end gap-10 inline-flex overflow-hidden">
                        <div className=" rounded-lg w-full max-w-[80%] h-full max-h-[90%] flex flex-col">
                            <div className="flex justify-between items-center p-4">
                                <div className="flex items-center gap-4">
                                    <a href={config.urlArquivo(selectedPdf)} download target="_blank">
                                        <img className="w-6 h-6 relative  overflow-hidden" src="/images/icon/download.png" />
                                    </a>
                                    <div className="w-6 h-6 relative  overflow-hidden" />
                                    <div className="w-6 h-6 relative  overflow-hidden" />
                                </div>
                                <img className="w-6 h-6 relative  overflow-hidden cursor-pointer" src="/images/icon/x.png" onClick={handleCloseDialog} />
                            </div>
                            <div className="flex-grow flex justify-center items-center p-4 overflow-hidden">
                                <iframe
                                    src={`${config.urlArquivo(selectedPdf)}#toolbar=0`}
                                    className="w-full h-full border-0"
                                    style={{ border: 'none' }}
                                    title="PDF Viewer"
                                />
                            </div>
                        </div>
                    </div>
                )}
            </form>
        </Template>
    );
};

export default CadastrarDocumento;
